<template>
    <QueryEventBundle
        :lazy="true"
        :query="eventBundleQuery"
    >
        <template #default="{ events, loadMore, lastPageNumber, currentPageNumber, totalResults }">
            <BaseSection
                v-if="events && events.length > 0"
                :width="sectionWidth"
                :color-theme="presentation === 'list' ? 'dark' : colorTheme"
                :class="{ 'section--event-list': presentation === 'list' }"
                data-spacing="lg"
            >
                <template
                    v-if="$slots.title"
                    #title
                >
                    <slot name="title" />
                </template>

                <template
                    v-if="!!$slots.readMore"
                    #readMore
                >
                    <slot name="readMore" />
                </template>

                <template #default>
                    <EventSlider
                        v-if="presentation === 'slider'"
                        key="results"
                        :events="events"
                        :card-size="cardSize"
                    />

                    <EventList
                        v-else-if="presentation === 'list'"
                        :events="events"
                        class="event-list--end-of-page"
                    >
                        <template #default="{ event }">
                            <EventDateCard
                                appearance="list"
                                :event="event"
                            />
                        </template>

                        <template
                            v-if="lastPageNumber && currentPageNumber < lastPageNumber"
                            #loadMore
                        >
                            <BaseButton
                                type="button"
                                class="event-list__load-more button--clean"
                                @click="loadMore"
                            >
                                Toon meer programma's
                            </BaseButton>
                        </template>

                        <template
                            v-else-if="events.length === totalResults && lastPageNumber !== 1"
                            #noResults
                        >
                            <p
                                class="event-list__no-results"
                            >
                                Je hebt alle programma's gezien
                            </p>
                        </template>
                    </EventList>

                    <EventGrid
                        v-else-if="presentation === 'grid'"
                        :events="events"
                    >
                        <template #default="{ event }">
                            <EventDateCard
                                appearance="box"
                                :event="event"
                            />
                        </template>

                        <template
                            v-if="lastPageNumber && currentPageNumber < lastPageNumber"
                            #loadMore
                        >
                            <BaseButton
                                type="button"
                                class="event-grid__load-more button--clean"
                                @click="loadMore"
                            >
                                Toon meer programma's
                            </BaseButton>
                        </template>

                        <template
                            v-else-if="events.length === totalResults && lastPageNumber !== 1"
                            #noResults
                        >
                            <p
                                class="event-grid__no-results"
                            >
                                Je hebt alle programma's gezien
                            </p>
                        </template>
                    </EventGrid>
                </template>
            </BaseSection>
        </template>

        <template #loading>
            <BaseLoader />
        </template>
    </QueryEventBundle>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
    cardSize?: 'default' | 'large';
    colorTheme?: string | null;
    presentation?: PresentationType;
    eventBundleQuery: QueryProp;
}>(), {
    cardSize: 'default',
    colorTheme: 'dark',
    presentation: 'grid'
});

const { presentation } = toRefs(props);

const sectionWidth = computed(() => {
    if (presentation.value === 'slider') {
        return 'bleed';
    }

    return 'page';
});
</script>
